export enum WaitReasons {
  MAX_RUNNING_BUILDS_NUMBER_REACHED = 'The maximum number of running builds for this configuration is reached',
  MAX_RUNNING_BUILDS_NUMBER_PER_BRANCH_REACHED = 'The maximum number of running builds in this branch is reached',
  TARGET_AGENT_DISCONNECTED = 'The selected agent is disconnected',
  TARGET_AGENT_INCOMPATIBLE = 'The selected agent is not compatible',
  TARGET_AGENT_INACCESSIBLE = 'The selected agent is from inaccessible pool of agents',
  TARGET_AGENT_OUTDATED = 'The selected agent is outdated, waiting for upgrade',
  TARGET_AGENT_OUTDATED_UPGRADE_DISABLED = 'The selected agent is outdated and cannot be upgraded to a newer version',
  WAITING_CHECKING_FOR_CHANGES = 'Waiting to start checking for changes',
  DEPENDENCY_NOT_READY = 'Build dependencies have not been built yet',
  WAITING_FOR_THE_FIRST_DEPENDENCY_TO_START = 'Waiting for the start of the first build in the build chain',
  CHECKING_FOR_CHANGES_IN_PROGRESS = 'Checking for changes is in progress',
  NO_COMPATIBLE_AGENTS_AVAILABLE = 'There are no idle compatible agents which can run this build',
  NO_AGENTS_WITH_MATCHED_RESTRICTIONS = 'There are no compatible agents which can run this build and match the specified restrictions',
  AGENTS_OUTDATED = 'All compatible agents are outdated, waiting for upgrade',
  AGENTS_OUTDATED_UPGRADE_DISABLED = 'All compatible agents are outdated and cannot be upgraded to a newer version',
  NO_ENABLED_COMPATIBLE_AGENTS = 'There are no enabled compatible agents which can run this build',
  WAITING_FOR_CLOUD_AGENT = 'Waiting for starting agent',
}
